exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n\n#sidebar {\n    width: 250px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 999;\n    background: #7386D5;\n    color: #fff;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n}\n\n.container-height {\n    height: 60px;\n}\n\n.container-content-height {\n    height: 120px;\n}\n\na.content-green {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 13px;\n    color: lightgreen;\n}\n\nb.size {\n    font-size: 14px;\n}\n\na.subtext {\n    font-family: \"Roboto-Regular\", sans-serif;\n    font-size: 13px;\n}\n\na.firmalar {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: #a5a4bf;\n}\n\na.firms {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: black;\n    font-weight: bold;\n    text-decoration: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-vendcard/firm-vendcard.component.css
// module id = ../../../../../src/app/firm-vendcard/firm-vendcard.component.css
// module chunks = main